const getApps = async _ => {
    const resp = await fetch("/apps");
    if (!resp.ok) { throw new Error(`HTTP ${resp.status}`); }
    return resp.json();
}

const createAppCard = app => {
    const card = document.createElement("a");
    card.className = "appCard grid";
    card.href = app.url || "#";
    card.target = "_blank";
    card.rel = "noopener noreferrer";

    const name = document.createElement("h3");
    name.className = "appName";
    name.textContent = app.name || "";

    const info = document.createElement("p");
    info.className = "appInfo";
    info.textContent = app.info || "";

    card.append(name, info);
    return card;
}

const createAppsGroup = group => {
    const groupWrap = document.createElement("div");
    groupWrap.className = "appsGroup";

    const title = document.createElement("h2");
    title.className = "groupName";
    title.textContent = group.group || "";

    const content = document.createElement("div");
    content.className = "groupContent grid";
    for (const app of (group.apps || [])) {
        content.append(createAppCard(app));
    }

    groupWrap.append(title, content);
    return groupWrap;
}

const createError = err => {
    const wrap = document.createElement("div");
    wrap.className = "error";

    const title = document.createElement("h2");
    title.textContent = "A sakra...";

    const message = document.createElement("p");
    message.textContent = (err && err.message) || "Nepovedlo se nacist seznam aplikaci.";

    wrap.append(title, message);
    return wrap;
}

const createPage = groups => {
    const block = document.createElement("div");
    block.className = "block flex";

    const heading = document.createElement("h1");
    heading.textContent = "itcan Apps";

    const appsGroups = document.createElement("div");
    appsGroups.className = "appsGroups flex";

    for (const group of (groups || [])) {
        appsGroups.append(createAppsGroup(group));
    }

    block.append(heading, appsGroups);
    return block;
}

(async _ => {
    const root = document.getElementById("root");
    if (!root) { return; }

    root.textContent = "";

    try {
        const groups = await getApps();
        root.append(createPage(groups));
    }
    catch (err) {
        const block = createPage([]);
        block.append(createError(err));
        root.append(block);
    }
})();
